import { render, staticRenderFns } from "./SingleBook.vue?vue&type=template&id=d3771e5e&scoped=true"
import script from "./SingleBook.vue?vue&type=script&lang=js"
export * from "./SingleBook.vue?vue&type=script&lang=js"
import style0 from "./SingleBook.vue?vue&type=style&index=0&id=d3771e5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3771e5e",
  null
  
)

export default component.exports